import {useAsyncEffect} from '@eitje/hooks'
import {backend} from '@eitje/api'
import {setArbitrary} from '~/hooks'

export const useFetchFinancial = () => {
	useAsyncEffect(async () => {
		const {ok, data} = await backend.get('stats/monthly_activity')
		if (ok && data?.items) {
			setArbitrary('financial', data.items)
		}
	}, [])
}
